import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { ShellAdminPanelComponent } from '@app/shell-admin-panel/shell-admin-panel.component';
import {
	AdminAssignModalComponent,
	AdminCreateOrgModalComponent,
	AdminDeleteModalComponent,
	AdminInviteUserModalComponent,
	AdminPermissionsModalComponent,
	AdminRawJsonModalComponent,
	AdminRecollectModalComponent,
	AdminRenameOrgModalComponent,
	AdminUpdateEmailsModalComponent,
} from '@modules/admin-panel/modals';
import { AdminOrgCollectionComponent } from '@modules/admin-panel/modals/admin-org-collection/admin-org-collection.component';
import { AdminModalPermissionsModule } from '@modules/admin-panel/modals/admin-permissions-modal/admin-modal-permissions/admin-modal-permissions.module';
import { ShowConfirmModule } from '@modules/shared/components/show-confirm/show-confirm.module';
import { ShowProcessModule } from '@modules/shared/components/show-process/show-process.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ClipboardCopyModule } from '@shared/clipboard-copy/clipboard-copy.module';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { NgxJsonViewerModule } from 'ngx-json-viewer';

@NgModule({
	imports: [
		// @Todo: refactor list of imports
		CommonModule,
		ShowProcessModule,
		MatFormFieldModule,
		ReactiveFormsModule,
		MatInputModule,
		MatSelectModule,
		ShowConfirmModule,
		NgxJsonViewerModule,
		MatRadioModule,
		FormsModule,
		MatCheckboxModule,
		ClipboardCopyModule,
		RouterModule,
		NgSelectModule,
		CollapseModule,
		AdminModalPermissionsModule,
	],
	providers: [],
	declarations: [
		ShellAdminPanelComponent,

		// @Todo: refactor list of components
		AdminOrgCollectionComponent,
		AdminUpdateEmailsModalComponent,
		AdminPermissionsModalComponent,
		AdminInviteUserModalComponent,
		AdminCreateOrgModalComponent,
		AdminRecollectModalComponent,
		AdminRenameOrgModalComponent,
		AdminRawJsonModalComponent,
		AdminAssignModalComponent,
		AdminDeleteModalComponent,
	],
})
export class ShellAdminPanelModule {}
